import { cn } from '@utils/cn';

interface LoadingProps {
    size?: 'sm' | 'md' | 'lg';
    className?: string;
    fullScreen?: boolean;
}

const sizes = {
    sm: 'w-5 h-5 border-2',
    md: 'w-8 h-8 border-2',
    lg: 'w-12 h-12 border-3',
};

export function Loading({ size = 'md', className, fullScreen }: LoadingProps) {
    const spinner = (
        <div
            className={cn(
                'rounded-full border-primary/30 border-t-primary animate-spin',
                sizes[size],
                className
            )}
        />
    );

    if (fullScreen) {
        return (
            <div className="fixed inset-0 bg-dark/80 backdrop-blur-sm flex items-center justify-center z-50">
                {spinner}
            </div>
        );
    }

    return spinner;
}

// Skeleton Loader Component
interface SkeletonProps {
    className?: string;
    variant?: 'text' | 'circular' | 'rectangular';
    width?: string | number;
    height?: string | number;
}

export function Skeleton({ className, variant = 'text', width, height }: SkeletonProps) {
    const baseClasses = 'bg-dark-100 animate-pulse';
    
    const variantClasses = {
        text: 'rounded h-4',
        circular: 'rounded-full',
        rectangular: 'rounded-lg',
    };

    return (
        <div
            className={cn(baseClasses, variantClasses[variant], className)}
            style={{ width, height }}
        />
    );
}

// Blog Card Skeleton
export function BlogCardSkeleton() {
    return (
        <div className="bg-surface-light rounded-xl p-6 space-y-4">
            <div className="flex items-center gap-3">
                <Skeleton variant="circular" width={40} height={40} />
                <div className="space-y-2 flex-1">
                    <Skeleton width="40%" height={14} />
                    <Skeleton width="25%" height={12} />
                </div>
            </div>
            <Skeleton height={200} variant="rectangular" className="w-full" />
            <Skeleton width="80%" height={20} />
            <Skeleton width="60%" height={16} />
            <div className="flex gap-4 pt-2">
                <Skeleton width={60} height={20} />
                <Skeleton width={60} height={20} />
            </div>
        </div>
    );
}

export default Loading;
